<template>
  <div class="section section-3" id="medallero">
    <div class="container">
      <div class="row">
        <div class="section-2__box-title py-3">
          <h2 class="section__title">Calendario del<br> Team Chile y medallero</h2>
          <!--<img src="@/assets/image/logoolimpiadas.png" class="img-fluid">-->
        </div>
        <div class="contenedor_tabla">
          <app-description-medallero-olimpico />
        </div>
        <div class="contenedor_tabla">
          <app-description-calendario-olimpico />
        </div>
        <!--<div class="section-2__box-title" id="todalasmedallas">
          <h2 class="section__title py-3">Las medallas de<br> nuestro país por disciplina</h2>
        </div>-->
        <div class="contenedor_tabla" >
          <app-description-disciplinas-ganadas />
        </div>
        <div class="contenedor_tabla">
          <app-description-chile-juegos-olimpicos-timeline />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppDescriptionMedalleroOlimpico from '@/components/commons/AppDescriptionMedalleroOlimpico.vue'
import AppDescriptionCalendarioOlimpico from '@/components/commons/AppDescriptionCalendarioOlimpico.vue'
import AppDescriptionChileJuegosOlimpicosTimeline from '@/components/commons/AppDescriptionChileJuegosOlimpicosTimeline.vue'
import AppDescriptionDisciplinasGanadas from '@/components/commons/AppDescriptionDisciplinasGanadas.vue'
export default {
  components: { AppDescriptionMedalleroOlimpico, AppDescriptionCalendarioOlimpico, AppDescriptionChileJuegosOlimpicosTimeline, AppDescriptionDisciplinasGanadas }
}
</script>